<template>
    <v-layout v-if="findWordBlock === true">
            <v-flex class="xs12">
                <v-flex class="xs12">
                    <v-select
                            :items="findTypes"
                            label="Условие поиска"
                            v-model="messageModel.find_type"
                            value="0"
                            item-text="text"
                            item-value="value"
                            @change="changeFindType"
                    ></v-select>
                </v-flex>

                <v-flex class="xs12">
                    <v-combobox
                            v-model="wordsToFind"
                            chips
                            label="Слова для поиска"
                            multiple
                            clearable
                            persistent-hint
                    >
                        <template v-slot:selection="data">
                            <v-chip
                                    v-bind="data.attrs"
                                    :input-value="data.selected"
                                    close
                                    @click:close="removeWord(data.index)"
                            >
                                {{ data.item }}
                            </v-chip>
                        </template>
                    </v-combobox>
                </v-flex>
            </v-flex>
    </v-layout>
</template>

<script>

export default {
    name: 'MessageFindWordBlock',
    data() {
        return {
            findTypes: [
                { value: 0, text: 'Выключено' },
                { value: 1, text: 'Совпадает с ключевым словом' },
                { value: 2, text: 'Содержит одно из ключевых слов' },
                { value: 3, text: 'Любое совпадение' }
            ]
        }
    },
    props: ['messageModel', 'findWordBlock'],
    methods: {
        changeFindType() {
            if (this.messageModel.find_type === 0) {
                this.messageModel.words_to_find = null
            }
            this.$emit('saveMessage')
        },
        removeWord(index) {
            let wordsToFind = this.messageModel.words_to_find.split(',')
            wordsToFind.splice(index, 1)
            this.messageModel.words_to_find = wordsToFind.join(',')
            this.$emit('saveMessage')
        }
    },
    computed: {
        wordsToFind: {
            get() {
                return this.messageModel.find_type !== 0 
                    ? (this.messageModel.words_to_find !== null && this.messageModel.words_to_find !== undefined ? this.messageModel.words_to_find.split(',') : []) 
                    : []
            },
            set(value) {
                this.messageModel.words_to_find = value.join(',')
                this.$emit('saveMessage')
            }
        }
    }
}
</script>

<style scoped>

</style>
